"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    // FETCH
    function fetchRequest(parent, id) {
        return {
            type: _ActionTypes.FETCH_REQUEST,
            payload: {
                parent,
                id
            }
        };
    }
    function fetchSuccess(boards) {
        return {
            type: _ActionTypes.FETCH_SUCCESS,
            payload: boards
        };
    }
    function fetchFailed(error) {
        return {
            type: _ActionTypes.FETCH_FAILED,
            payload: error
        };
    }
    // CREATE
    function createRequest(parent, id, dashboard) {
        return {
            type: _ActionTypes.CREATE_REQUEST,
            payload: {
                parent,
                id,
                dashboard
            }
        };
    }
    function createSuccess(board) {
        return {
            type: _ActionTypes.CREATE_SUCCESS,
            payload: board
        };
    }
    function createFailed(error) {
        return {
            type: _ActionTypes.CREATE_FAILED,
            payload: error
        };
    }
    function createValidationFailure(error) {
        return {
            type: _ActionTypes.CREATE_VALIDATION_FAILURE,
            payload: error
        };
    }
    // EDIT
    function editRequest(parent, id, dashboard) {
        return {
            type: _ActionTypes.EDIT_REQUEST,
            payload: {
                parent,
                id,
                dashboard
            }
        };
    }
    function editSuccess(board) {
        return {
            type: _ActionTypes.EDIT_SUCCESS,
            payload: board
        };
    }
    function editFailed(error) {
        return {
            type: _ActionTypes.EDIT_FAILED,
            payload: error
        };
    }
    function editValidationFailure(error) {
        return {
            type: _ActionTypes.EDIT_VALIDATION_FAILURE,
            payload: error
        };
    }
    // REMOVE
    function removeRequest(parent, id, dashboard) {
        return {
            type: _ActionTypes.REMOVE_REQUEST,
            payload: {
                parent,
                id,
                dashboard
            }
        };
    }
    function removeSuccess(board) {
        return {
            type: _ActionTypes.REMOVE_SUCCESS,
            payload: board
        };
    }
    function removeFailed(error) {
        return {
            type: _ActionTypes.REMOVE_FAILED,
            payload: error
        };
    }
    function changeModalStatus(modal, status, item = null) {
        return {
            type: _ActionTypes.CHANGE_MODAL_STATUS,
            payload: {
                modal,
                status,
                item
            }
        };
    }
    function updateModalItem(key, value) {
        return {
            type: _ActionTypes.UPDATE_MODAL_ITEM,
            payload: {
                key,
                value
            }
        };
    }
    function addElement(type) {
        return {
            type: _ActionTypes.ADD_ELEMENT,
            payload: type
        };
    }
    function updateElement(position, key, value) {
        return {
            type: _ActionTypes.UPDATE_ELEMENT,
            payload: {
                position,
                key,
                value
            }
        };
    }
    function removeElement(index) {
        return {
            type: _ActionTypes.REMOVE_ELEMENT,
            payload: index
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    return {
        fetchRequest,
        fetchSuccess,
        fetchFailed,
        createRequest,
        createSuccess,
        createFailed,
        createValidationFailure,
        editRequest,
        editSuccess,
        editFailed,
        editValidationFailure,
        removeRequest,
        removeSuccess,
        removeFailed,
        changeModalStatus,
        updateModalItem,
        addElement,
        updateElement,
        removeElement,
        clear
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map